import React, { useState } from 'react';
import { Box } from '@mui/material';
import HomeMenu from './gestor/homemenu';
import FornecedorLayout from './gestor/fornecedor/FornecedorLayout';
import ClientesLayout from './gestor/clientes/clienteslayout'; 
import ArtigosLayout from './gestor/artigos/artigoslayout';
import AnalisesLayout from './gestor/analises/analiseslayout'; 
import FamiliasLayout from './gestor/familias/familiaslayout'; 
import MovimentosLayout from './gestor/movimentos/movimentoslayout'; 



const Gestor = () => {
  const [selectedLayout, setSelectedLayout] = useState('fornecedores');

  // Função que altera o layout de acordo com o item selecionado
  const handleSelectOption = (option) => {
    setSelectedLayout(option);
  };

  return (
    <Box sx={{ p: 2 }}>
      <HomeMenu onSelectOption={handleSelectOption} />
      {selectedLayout === 'fornecedores' && <FornecedorLayout />}
      {selectedLayout === 'clientes' && <ClientesLayout />}
      {selectedLayout === 'artigos' && <ArtigosLayout />}
      {selectedLayout === 'analises' && <AnalisesLayout />}
      {selectedLayout === 'familias' && <FamiliasLayout />}
      {selectedLayout === 'movimentos' && <MovimentosLayout />}


      {/* Você pode adicionar outros layouts conforme necessário */}
    </Box>
  );
};

export default Gestor;
